import { apiFetch } from "../../services/api-fetch";
import ModalNonBlocked from "../modal/modal-non-blocked";
import { updateNotificationsCount } from "./update-count";

let notificationsModal, notificationsList;
let notificationsNoAuth = null;
let inited = false;

const init = () => {
  if (inited) return;

  let notificationsModalElement = document.getElementById("notifications-list");
  let notificationsNoAuthParent = document.getElementById("notifications-no-auth");

  if (notificationsModalElement) {
    notificationsModal = ModalNonBlocked.get(notificationsModalElement);
    notificationsList = notificationsModalElement.querySelector('.notifications-list__items')
  }

  notificationsNoAuth = document.createElement("div");

  if (notificationsNoAuthParent) {
    while (notificationsNoAuthParent.firstChild) {
      notificationsNoAuth.appendChild(notificationsNoAuthParent.firstChild);
    }
  }

  inited = true;
}

const loadNotifications = (action, el, noAuthWindow = false) => {
  if (noAuthWindow && !window.authorized)
  {
    if (!inited) init();

    notificationsModal.root.setAttribute("data-loaded", "");
    notificationsModal.open(false, el);
    notificationsList.innerHTML = window.notificationsHTML || '';
    window.notificationsHTML = '';
    window.notificationsCount = 0;

    return;
  }

  if (!inited) init();

  if (!notificationsModal) return;

  notificationsModal.root.removeAttribute("data-loaded");
  notificationsModal.root.removeAttribute("data-error");
  notificationsList.innerHTML = "";

  notificationsModal.root.setAttribute("data-loading", "");
  notificationsModal.open(false, el);

  if (!window.authorized) {
    notificationsModal.root.removeAttribute("data-loading");
    notificationsModal.root.setAttribute("data-loaded", "");
    notificationsList.innerHTML = notificationsNoAuth.innerHTML;
  }
  else {
    apiFetch(action, {
      method: "POST"
    })
    .then(res => {
      notificationsModal.root.removeAttribute("data-loading");
      if (res.success) {
        let html = window.notificationsHTML || '';
  
        if (!html || (html && res.notifications && res.notifications.length))
        {
          html += res.html;
        }
  
        notificationsModal.root.setAttribute("data-loaded", "");
        notificationsList.innerHTML = html;
        window.notificationsHTML = '';
        window.notificationsCount = res.remainingCount;
        updateNotificationsCount(res.remainingCount);
      }
    })
    .catch(err => {
      notificationsModal.root.removeAttribute("data-loading");
      notificationsModal.root.setAttribute("data-error", "");
      console.error(err);
    })
  }
};

export { loadNotifications };